import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';

interface TradingPageContentType {
    isV2Page: boolean;
}

const tradingPageV2Content = (isV2Page: boolean): SerializedStyles => {
    if (isV2Page) {
        return css`
            margin: 12px 12px 12px 0;
            border-radius: 6px;
            overflow-y: auto;
            max-height: calc(100vh - 24px);
            flex: 0 0 calc(100% - 300px);
            max-width: calc(100% - 300px);
        `;
    }
        return css`
            flex: 0 0 calc(100% - 248px);
            max-width: calc(100% - 248px);
        `;
};

export const TradingPageContent = styled('div', { label: 'TradingPageContent' })<TradingPageContentType>`
    background: #fff;
    display: flex;
    flex-flow: column nowrap;
    padding: 24px;
    ${(props): SerializedStyles => tradingPageV2Content(props.isV2Page) }
`;
